<template>
  <BaseLayout>
    <div class="page-single">
      <b-container
        fluid
      >
        <b-row class="justify-content-center">
          <b-col class=" col-login">
            <div class="text-center mb-4">
              <img
                src="/images/logo.png"
                class="h-8"
                alt="logo"
              >
            </div>

            <b-form
              class="card"
              @submit.prevent="confirm"
            >
              <div class="card-body p-6">
                <div class="card-title">
                  A new password is required
                </div>
                <b-form-group
                  id="email-address-group-1"
                  label="Email address:"
                  label-for="email-address-input"
                  label-class="form-label"
                  v-if="showEmailInput"
                >
                  <b-form-input
                    id="email-address-input"
                    v-model="email"
                    type="email"
                    required
                    placeholder="Enter email"
                    autocomplete="off"
                    data-test="email-input"
                    autofocus
                  />
                </b-form-group>

                <b-form-group
                  id="password-group-1"
                  label="Old Password:"
                  label-for="old-password-input"
                  label-class="form-label"
                >
                  <b-form-input
                    id="old-password-input"
                    v-model="password"
                    type="password"
                    required
                    placeholder="Password"
                    autocomplete="off"
                    data-test="old-password-input"
                  />
                </b-form-group>
                <b-alert
                  show
                  variant="info"
                  class="multiline"
                >
                  <small>
                    Password requirements:
                    <ul class="mb-0 pl-3">
                      <li>Minimum length of 8 characters</li>
                      <li>At least 1 number</li>
                      <li>At least 1 special character from this set:<br>
                        ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , > ' : ; | _ ~ `
                      </li>
                      <li>At least 1 uppercase letter</li>
                      <li>At least 1 lowercase letter</li>
                    </ul>
                  </small>
                </b-alert>
                <b-form-group
                  id="password-group-2"
                  label="New Password:"
                  label-for="new-password-input"
                  label-class="form-label"
                >
                  <b-form-input
                    id="new-password-input"
                    v-model="newPassword"
                    type="password"
                    required
                    placeholder="Password"
                    autocomplete="off"
                    data-test="new-password-input"
                  />
                </b-form-group>
                <div class="form-footer">
                  <button
                    type="submit"
                    class="btn btn-primary btn-block"
                    :disabled="!email"
                    data-test="forgot-password-confirm-submit"
                    :class="{ 'btn-loading': isLoading }"
                  >
                    Sign in
                  </button>
                </div>
              </div>
            </b-form>
            <div class="text-center text-muted mt-4">
              Need support? Contact our team <a
                href="mailto:support@smartology.net"
                target="_blank"
              >support@smartology.net</a>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </BaseLayout>
</template>

<script>
import { Auth } from 'aws-amplify';
import { mapActions, mapState, mapMutations } from 'vuex';
import * as types from '@/store/types';
import * as authenticationTypes from '@/modules/authentication/store/types';

export default {
  name: 'NewPasswordRequired',
  data() {
    return {
      email: '',
      password: '',
      newPassword: '',
      showEmailInput: true,
      clicked: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapState('authentication', {
      user: 'user',
    }),
  },
  methods: {
    ...mapActions('authentication', [
      authenticationTypes.SIGN_IN,
      authenticationTypes.COMPLETE_NEW_PASSWORD,
    ]),
    ...mapMutations([
      types.SET_GLOBAL_MESSAGE,
    ]),
    confirm() {
      if (this.clicked) return;
      this.clicked = true;
      this.isLoading = true;

      Auth
        .signIn({
          username: this.email,
          password: this.password,
        })
        .then(async (user) => {
          try {
            await this.COMPLETE_NEW_PASSWORD(
              {
                user,
                password: this.newPassword,
              },
            );
            this.clicked = false;
            this.isLoading = false;
            this.$router.push(this.$route.query.redirect
              ? `/login?redirect=${this.$route.query.redirect}`
              : '/login');
          } catch {
            this.clicked = false;
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.clicked = false;
          this.isLoading = false;
          this.SET_GLOBAL_MESSAGE({
            message: 'Invalid email or password',
            type: 'danger',
          });
        });
    },
  },
  created() {
    this.showEmailInput = this.user ? !this.user.email : true;
    if (!this.showEmailInput) {
      this.email = this.user.email;
    }
  },
};
</script>
